<template>
  <v-toolbar
    fixed
    app
    height="52"
    color="white"
    style="z-index: 3"
    class="elevation-1"
  >
    <v-toolbar-side-icon :round="false" @click="toggleRNav" />
    <!-- <v-btn flat icon class="ma-0 pa-0" @click="$router.go(-1)">
      <v-icon
        small
        v-html="$vuetify.rtl ? 'arrow_forward_ios' : 'arrow_back_ios'"
      />
    </v-btn>

    <v-btn flat icon class="ma-0 pa-0" @click="$router.go(1)">
      <v-icon
        small
        v-html="$vuetify.rtl ? 'arrow_back_ios' : 'arrow_forward_ios'"
      />
    </v-btn> -->
    <v-spacer />
    <!-- <v-spacer /> -->
    <v-menu offset-y nudge-bottom="13" content-class="elevation-1">
      <v-btn slot="activator" color="primary" class="ma-0 pa-0" flat>
        <!-- <span>{{ lang.text }}</span> -->
        <strong class="secondary--text">{{ $t("links") }}</strong>
      </v-btn>
      <v-list>
        <v-list-tile
          class="align-center di-flex my-0"
          href="http://sanctionscreening.dab.gov.af:5050/search/sanctions"
          target="_blank"
        >
          <v-list-tile-avatar tile color="" size="32">
            <img src="@/assets/images/dablogo.png" style="width: 40px" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="body-1 font-weight-medium">
              <span class="indigo--text">Screening</span>
              <v-icon size="16" color="indigo" class="mx-1 mb-1"
                >mdi-open-in-new</v-icon
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          class="align-center di-flex my-0"
          href="http://exchange.dab.gov.af/home/"
          target="_blank"
        >
          <v-list-tile-avatar tile color="" size="32">
            <img src="@/assets/images/dablogo.png" style="width: 40px" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="body-1 font-weight-medium">
              <span class="indigo--text">Daily Rate Report</span>
              <v-icon size="16" color="indigo" class="mx-1 mb-1"
                >mdi-open-in-new</v-icon
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          class="align-center di-flex my-0"
          href="https://reports.fintraca.gov.af/Login.aspx"
          target="_blank"
        >
          <v-list-tile-avatar tile color="" size="32">
            <img src="@/assets/images/dablogo.png" style="width: 40px" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="body-1 font-weight-medium">
              <span class="indigo--text">Fintraca Reports</span>
              <v-icon size="16" color="indigo" class="mx-1 mb-1"
                >mdi-open-in-new</v-icon
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          class="align-center di-flex my-0"
          href="https://online.dab.gov.af/auction/Account/Login"
          target="_blank"
        >
          <v-list-tile-avatar tile color="" size="32">
            <img src="@/assets/images/dablogo.png" style="width: 40px" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="body-1 font-weight-medium">
              <span class="indigo--text">DAB Action</span>
              <v-icon size="16" color="indigo" class="mx-1 mb-1"
                >mdi-open-in-new</v-icon
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-menu
      offset-y
      width="200px"
      nudge-bottom="13"
      content-class="elevation-1"
    >
      <v-btn icon slot="activator" color="primary" class="ma-0 pa-0" flat>
        <!-- <span>{{ lang.text }}</span> -->
        <strong class="secondary--text">{{ lang.text }}</strong>
      </v-btn>
      <v-list>
        <v-list-tile
          :key="index"
          @click="changeLang(item)"
          v-for="(item, index) in langs"
        >
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-btn
      flat
      icon
      color="bp_green"
      :class="{ 'mr-3': $vuetify.rtl }"
      @click="toggleLNav"
    >
      <v-icon>info</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["rdrawer", "ldrawer"],

  data: () => ({
    langs: [
      { text: "EN", value: "en", dir: "ltr" },
      { text: "FA", value: "fa", dir: "rtl" },
      { text: "PS", value: "pa", dir: "rtl" },
    ],
  }),

  computed: {
    ...mapGetters("AuthModule", { current_user: "current_user" }),

    lang() {
      return this.$store.state.lang;
    },
    user() {
      return this.current_user.user || {};
    },
  },

  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang.value;
      this.$store.commit("setLang", lang);
      this.$validator.localize(lang.value);
      this.$vuetify.rtl = lang.dir == "rtl";
      this.$vuetify.lang.current = lang.value;
      localStorage.setItem("lang", JSON.stringify(lang));
    },

    toggleRNav() {
      this.$emit("update:rdrawer", !this.rdrawer);
    },

    toggleLNav() {
      this.$emit("update:ldrawer", !this.ldrawer);
    },
  },
};
</script>
